import { Heading } from '@/components/ui/heading';
import { Text } from '@/components/ui/text';
import { PaymentsPortalButton } from '@features/PaymentsPortalButton';
import { Motion, Presence } from 'solid-motionone';
import { Grid } from 'styled-system/jsx';
import { grid } from 'styled-system/patterns';

export function FocusBody(props: { title: string; text: string }) {

  return (
    <Presence>
      <Motion.div
        initial={{ opacity: 0, y: 20, scale: 0.95, filter: 'blur(10px)' }}
        animate={{ opacity: 1, y: 0, scale: 1, filter: 'blur(0px)' }}
        exit={{ opacity: 0, y: -20, scale: 0.95, filter: 'blur(10px)' }}
        transition={{ duration: 0.5, easing: [0.19, 1, 0.22, 1] }}
        class={grid({
          alignContent: 'center',
          justifyContent: 'center',
          justifyItems: 'center',
        })}
      >
        <Grid maxWidth='xl' gap={3} textAlign='center'>
          <Heading textStyle='2xl'>{props.title}</Heading>
          <Text>{props.text}</Text>
        </Grid>
        <div>
          <PaymentsPortalButton />
        </div>
      </Motion.div>
    </Presence>
  )
}
